// This file manages exports from the base atom, molecule, or organism.

import dynamic from 'next/dynamic';

export const AmbassadorElitePreferencesEditable = dynamic(() =>
  import('./AmbassadorElitePreferences').then(mod => mod.AmbassadorElitePreferencesEditable)
);
